import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["button", "status"]

  async perform(event) {
    event.preventDefault()
    
    const originalContent = this.element.innerHTML
    this.element.style.opacity = "0.5"
    this.element.style.pointerEvents = "none"

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'application/json'
        }
      })

      if (response.ok) {
        const data = await response.json()
        // Replace the button with a green checkmark
        this.element.innerHTML = `
          <svg class="w-4 h-4 text-green-500 mx-auto" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
          </svg>
        `
        this.element.classList.remove('bg-white', 'border-gray-100')
        this.element.classList.add('bg-green-50', 'border-green-100')
        
        // Refresh after a short delay to clear the handshake card
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      } else {
        alert("Check-in failed. Please try again.")
        this.element.style.opacity = "1"
        this.element.style.pointerEvents = "auto"
      }
    } catch (error) {
      console.error("Check-in error:", error)
      alert("Network error. Please try again.")
      this.element.style.opacity = "1"
      this.element.style.pointerEvents = "auto"
    }
  }
}
